<div class="infoCard_container">
    <p class="title_paragraph">¿Necesitas ayuda con la tramitación del kit digital?</p>
    <div class="carta">
        <div class="info_kitCard" *ngFor="let item of infoCard">
            <img src="{{item.icon.src}}" alt="{{item.icon.alt}}">
            <p>{{item.text}}</p>
        </div>
    </div>
    
</div>

